import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Box,
  Flex,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import React from "react";
import { FaDesktop, FaMobileAlt, FaTabletAlt } from "react-icons/fa";
import FormLayout from "../../CustomOnboarding/CustomOnboarding/component/Forms/FormLayout";
import { elements } from "chart.js";
import { FaArrowLeft } from "react-icons/fa";

const tabPanels = [
  { type: "mobile", height: "512px", width: "278px" },
  { type: "tab", height: "512px", width: "354px" },
  { type: "desktop", height: "512px", width: "900px" },
];

type ViewFormModalProps = {
  elements: any;
  designElements: any;
  activePage: any;
  setActivePage: React.Dispatch<React.SetStateAction<any>>;
};
function ViewFormModal({
  elements,
  designElements,
  activePage,
  setActivePage,
}: ViewFormModalProps) {
  const tabStyles = {
    // _hover: { color: "teal.400", bg: "teal.50" },

    fontWeight: "700",
    fontSize: { base: "1rem", md: "1.6rem" },
    cursor: "pointer",
    color: "teal.500",
  };
  return (
    <Tabs variant="enclosed" p={0} m={0} defaultIndex={2}>
      <Flex justifyContent="space-between">
        <Box>
          <Tooltip label="Back" hasArrow arrowSize={5} placement="right">
            <Button
              bg="tranparent"
              color="teal.500"
              _hover={{ bg: "transparent" }}
              fontSize={{ base: "1rem", md: "1.2rem" }}
              onClick={() => setActivePage({ page: 1, data: null })}
            >
              <FaArrowLeft />
            </Button>
          </Tooltip>
        </Box>
        <TabList>
          <Tab {...tabStyles}>
            <FaMobileAlt />
          </Tab>
          <Tab {...tabStyles}>
            <FaTabletAlt />
          </Tab>
          <Tab {...tabStyles}>
            <FaDesktop />
          </Tab>
        </TabList>
      </Flex>

      <TabPanels>
        {tabPanels.map((panel, index) => (
          <TabPanel key={panel.type}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="70vh"
            >
              <Box
                h={panel.height}
                w={panel.width}
                overflow="auto"
                className="customScrollBar"
                border="1px solid"
                borderColor="gray.200"
                p={2}
              >
                <FormLayout
                  elements={elements}
                  designElement={designElements}
                  type={panel.type}
                />
              </Box>
            </Box>
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
}

export default ViewFormModal;
